import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

/**
 * Arcano & Project Store
 * Manages arcano selection, projects, and related state
 */
export const useArcanoStore = create(
  devtools(
    persist(
      set => ({
        // ==================== State ====================
        arcanos: [],
        selectedArcano: null,
        arcanoRestorationComplete: false,

        selectedProject: null,

        // ==================== Actions ====================

        // Arcanos
        setArcanos: arcanos => set({ arcanos }),

        setSelectedArcano: arcano => set({ selectedArcano: arcano }),

        clearSelectedArcano: () => set({ selectedArcano: null }),

        setArcanoRestorationComplete: complete =>
          set({ arcanoRestorationComplete: complete }),

        // Projects
        setSelectedProject: project => set({ selectedProject: project }),

        clearSelectedProject: () => set({ selectedProject: null }),

        // Combined operations
        selectArcanoAndClearProject: arcano =>
          set({ selectedArcano: arcano, selectedProject: null }),

        selectProjectAndClearArcano: project =>
          set({ selectedProject: project, selectedArcano: null }),

        clearBothSelections: () => set({ selectedArcano: null, selectedProject: null }),
      }),
      {
        name: 'arcano-storage',
        partialize: state => ({
          selectedArcano: state.selectedArcano,
        }),
      }
    ),
    { name: 'ArcanoStore' }
  )
)
